import React, {Children} from "react";
import PropTypes from "prop-types";

const FauxHeaderInline = ({children}) => (
  <div className={"FauxHeaderInline-Root"}>
    {Children.toArray(children).map((child, index) => (
      <div key={index} className={"FauxHeaderInline-Child"}>
        {child}
      </div>
    ))}
  </div>
);

FauxHeaderInline.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

export default FauxHeaderInline;